import { render, staticRenderFns } from "./AFUserManagementDetailsScreen.vue?vue&type=template&id=796eb29d&scoped=true&"
import script from "./AFUserManagementDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./AFUserManagementDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796eb29d",
  null
  
)

export default component.exports